import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeleteSitePricingPlanFormModal from 'src/features/pricing/sites/components/form/DeleteSitePricingPlanFormModal';
import UpdateSitePricingPlanFormModal from 'src/features/pricing/sites/components/form/UpdateSitePricingPlanFormModal';
import { pricingPlanMessages } from 'src/features/pricing/messages';
import { SitePricingPlan } from 'src/features/pricing/sites/utils/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellSitePricingPlanActions({ row }: CellContext<SitePricingPlan, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateSitePricingPlanFormModal
                        selectedSitePricingPlan={row.original}
                        semantics={{ entryName: formatMessage(pricingPlanMessages.pricingPlan).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateSitePricingPlanFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteSitePricingPlanFormModal
                        selectedSitePricingPlan={row.original}
                        semantics={{ entryName: formatMessage(pricingPlanMessages.pricingPlan).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteSitePricingPlanFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
